import React from 'react';
import { Col, Content, FlexboxGrid, Grid, Row, Text } from 'rsuite';
import PortalHeader from '../../components/layout/PortalHeader';
import FlowPageLayout from '../../components/layout/FlowPageLayout';
import { useSelector } from 'react-redux';
import {
  selectConfigExpressRegistrationVerbiage,
  selectConfigExpressRenewRequirements,
} from '../../store/slices/config/configSelectors';
import { FLOWS_ENUM } from '../../common/enums';
import RequirementsList from '../../components/common/RequirementsList';

const RenewRequirements = () => {
  const selectedRequirements = useSelector(
    selectConfigExpressRenewRequirements
  );
  const permitName = useSelector(selectConfigExpressRegistrationVerbiage);

  return (
    <FlexboxGrid justify="space-between">
      <FlexboxGrid.Item colspan={24}>
        <PortalHeader flow={FLOWS_ENUM.RENEW_LICENSE} />
      </FlexboxGrid.Item>
      <FlexboxGrid.Item colspan={24}>
        <Content as="div">
          <FlowPageLayout title="Renewal Requirements">
            <Grid
              className="mt-12 ml-0"
              fluid
            >
              <Row className="mb-32">
                <Col x={24}>
                  <Text>
                    Let's make sure you have everything you need to renew your{' '}
                    {permitName}.
                  </Text>
                </Col>
              </Row>
              <RequirementsList requirements={selectedRequirements} />
            </Grid>
          </FlowPageLayout>
        </Content>
      </FlexboxGrid.Item>
    </FlexboxGrid>
  );
};

export default RenewRequirements;
